import React, {Component} from 'react';
import {Grid} from 'semantic-ui-react';
import headerBorder from '../../assets/images/line-orange.png';
import topPlane from '../../assets/images/icn-plane-top.png';
import bottomPlane from '../../assets/images/icn-plane-bottom.png';
import dottedLine from '../../assets/images/dotted-line.png';

export default class TourItinerary extends Component{
	render(){
		let {portrait, landscape, day, utf, itinerary, highlights, inclusions, fees, exclusions, biblicalref, hotel} = this.props;
		return (
			<>
				{(itinerary && itinerary.length > 0) &&
					<>
						<h1 className="section-header align-center">Itinerary</h1>
						<div className="align-center"><img src={headerBorder} className="header-border align-center" alt="" /></div>
						<Grid className="tour-info-wrapper">
							<Grid.Column width={7}>
								<div className="tour-photo-wrapper">
									<img alt="" src={portrait} className="photo-portrait"/>
									<img alt="" src={landscape} className="photo-landscape"/>
								</div>
							</Grid.Column>
							<Grid.Column width={9}>
								<Grid className="itinerary-wrapper">
									<Grid.Column width={3} className="tour-day">
										{
											day.map((paragraph, i) => (
												<div className="para-content" key={i}>{paragraph}</div>
											)
										)}
										
									</Grid.Column>
									<Grid.Column width={1}  className="tour-dot">
										<img src={topPlane} className="icn-tour-plane top-plane" alt="" />
										{
											utf.map((paragraph, i) => (
												<div className="dot-wrapper" key={i}>
													<img src={paragraph} className="dot" alt="" />
													<img src={dottedLine} className="dotted-line" alt="" />
												</div>
											)
										)}
										<img src={bottomPlane} className="icn-tour-plane bottom-plane" alt="" />
									</Grid.Column>
									<Grid.Column width={10} className="tour-place">
										{
											itinerary.map((paragraph, i) => (
												<div className="para-content" key={i}>{paragraph}</div>
											)
										)}
											</Grid.Column>
								</Grid>
							</Grid.Column>
						</Grid>
					</>
				}
				
				{(highlights && highlights.length > 0) &&
					<div className="margin-top-5">
						<h1 className="section-header align-center">Highlights</h1>
						<div className="align-center"><img src={headerBorder} className="header-border align-center" alt="" /></div>
					
						<Grid className="inclusions-details">
							<Grid.Column width={16}>
								<ul className="inclusions-list">
									{
										highlights.map((paragraph, i) => (
											<li className="para-content" key={i}>
												{paragraph}
											</li>
											)
										)
									}
								</ul>
							</Grid.Column>
						</Grid>			
					</div>
				}	

				{(biblicalref && biblicalref.length > 0) &&
					<div className="margin-top-5">
						<h1 className="section-header align-center">Biblical References</h1>
						<div className="align-center"><img src={headerBorder} className="header-border align-center" alt="" /></div>
					
						<Grid className="inclusions-details">
							<Grid.Column width={16}>
								<ul className="inclusions-list">
									{
										biblicalref.map((paragraph, i) => (
											<li className="para-content" key={i}>
												{paragraph}
											</li>
											)
										)
									}
								</ul>
							</Grid.Column>
						</Grid>			
					</div>
				}	
				{(inclusions && inclusions.length > 0) &&
					<div className="margin-top-5">
						<h1 className="section-header align-center">Inclusions</h1>
						<div className="align-center"><img src={headerBorder} className="header-border align-center" alt="" /></div>
									
						<Grid className="inclusions-details">
							{
								inclusions.map((paragraph, i) => (
									<Grid.Column width={8} className="tour-itinerary"  key={i}>
										<ul >
											<li className="para-content">
												{paragraph}
											</li>
										</ul>
									</Grid.Column>
									)
								)
							}
						</Grid>

						<Grid className="inclusions-fees-details">
							{
								fees.map((paragraph, i) => (
									<Grid.Column width={8} className="tour-itinerary" key={i}>
										<ul>
											<li className="para-content" >
												{paragraph}
											</li>
										</ul>
									</Grid.Column>
									)
								)
							}
						</Grid>

					</div>
				} 

				{(hotel && hotel.length > 0) &&
					<div className="margin-top-5">
						<h1 className="section-header align-center">Suggested Hotels or similar</h1>
						<div className="align-center"><img src={headerBorder} className="header-border align-center" alt="" /></div>
					
						<Grid className="inclusions-details">
							<Grid.Column width={16}>
								<ul className="inclusions-list">
									{
										hotel.map((paragraph, i) => (
											<li className="para-content" key={i}>
												{paragraph}
											</li>
											)
										)
									}
								</ul>
							</Grid.Column>
						</Grid>			
					</div>
				}	

				{(exclusions && exclusions.length > 0) &&
					<div className="margin-top-5">
						<h1 className="section-header align-center">Exclusions</h1>
						<div className="align-center"><img src={headerBorder} className="header-border align-center" alt="" /></div>
									
						<Grid className="inclusions-details">
							{
								exclusions.map((paragraph, i) => (
									<Grid.Column width={8} className="tour-itinerary"  key={i}>
										<ul >
											<li className="para-content">
												{paragraph}
											</li>
										</ul>
									</Grid.Column>
									)
								)
							}
						</Grid>
					</div>
				} 
			</>
		);
	}
}
